export default __webpack_public_path__ + "d585c7df44df3024c49b575d40bd0eca.ttf";